<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'FormationsGrowthHacking'
});
</script>
<template>
  <ka-container
    code="prog-04-growth-hacking"
    :data="page.$info.prog04GrowthHacking">
    <!-- Page formation -->
    <ka-container code="page-formation">
      <PFormationEntete
        instance-class="p-formation-entete--p34"
        h-1="Formation en growth hacking"
        texte="La formation est réalisée par un<strong> expert en growth hacking</strong> issu d'une entreprise à succès." />
      <!-- Container experts -->
      <ka-container code="container-experts">
        <ka-text code="titre">
          <span v-html="t('prog04GrowthHacking.pageFormation.containerExperts.titre.value', `Nos experts en growth hacking`)" />
        </ka-text>
        <ka-text code="texte">
          <span v-html="t('prog04GrowthHacking.pageFormation.containerExperts.texte.value', `Nos experts en growth hacking sont des professionnels spécialisés dans la croissance rapide et digitalisée d'une entreprise. Pour la plupart, ils sont toujours en poste et mettent en place des actions et de nouvelles stratégies de growth hacking au quotidien. Grâce à leur coaching, vous pourrez mettre en place des actions concrètes de growth hacking pour acquérir de nouveaux clients à faible coût, améliorer le taux de conversion de votre site web, augmenter l'engagement de vos utilisateurs ou encore, constituer une base de données qualifiée.`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container">
          <BlocPreviewProfilExpert
            instance-class="bloc-preview-profil-expert--p34"
            :options="{
              href: `https://www.matchers.fr/expert/486`,
              ariaLabel: `bloc preview profil expert`,
              click: page.blocPreviewProfilExpertClick
            }"
            :xs="{ hidden: null }"
            :tags="page.$constants.blocPreviewProfilExpertTags"
            poste="Growth Marketer"
            first-name="Bryan"
            enttreprise="&#64;Shine"
            image="https://ucarecdn.com/6e801044-f6fc-49ac-bc13-c067e45af39f/" />
          <BlocPreviewProfilExpert
            instance-class="element-1--p34"
            :options="{
              href: `https://www.matchers.fr/expert/318`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element1Click
            }"
            :tags="page.$constants.element1Tags"
            poste="Acquisition manager"
            first-name="Lilia"
            enttreprise="&#64;Groupe Barrière"
            image="https://ucarecdn.com/5e7df746-2163-4fbb-a265-f9bbb848865b/" />
          <BlocPreviewProfilExpert
            instance-class="element-2--p34"
            :options="{
              href: `https://www.matchers.fr/expert/247`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element2Click
            }"
            :xs="{ hidden: null }"
            :tags="page.$constants.element2Tags"
            poste="Growth Engineer"
            first-name="Tuka"
            enttreprise="&#64;CodinGame"
            image="https://ucarecdn.com/ab460698-ae0f-4fec-a5a4-53121e120774/" />
          <BlocPreviewProfilExpert
            instance-class="element-3--p34"
            :options="{
              href: `https://www.matchers.fr/expert/333`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element3Click
            }"
            :tags="page.$constants.element3Tags"
            poste="Growth Marketing Specialist"
            first-name="Kévin"
            enttreprise="&#64;PayFit"
            image="https://ucarecdn.com/5bc9510c-645d-4079-80dc-8ecf4c7958fb/" />
        </ka-container>
        <ka-text
          code="voir"
          :options="{
            href: `https://www.matchers.fr/experts`,
            ariaLabel: `voir`,
            click: page.voirClick
          }">
          <span v-html="t('prog04GrowthHacking.pageFormation.containerExperts.voir.value', `Voir plus de profils >`)" />
        </ka-text>
      </ka-container>
      <!-- Container programme -->
      <ka-container code="container-programme">
        <!-- Container gauche -->
        <ka-container code="container-gauche">
          <!-- Container programme de formation -->
          <ka-container code="container-programme-de-formation">
            <!-- Titre exemple de programme -->
            <ka-container code="titre-exemple-de-programme">
              <ka-text code="voici-un-exemple-de">
                <h2 v-html="t('prog04GrowthHacking.pageFormation.containerProgramme.containerGauche.containerProgrammeDeFormation.titreExempleDeProgramme.voiciUnExempleDe.value', `Voici un exemple de programme de formation`)" />
              </ka-text>
            </ka-container>
            <!-- Module1 -->
            <ka-container code="module-1">
              <ka-text code="creer-une-base-de-prospection">
                <h2 v-html="t('prog04GrowthHacking.pageFormation.containerProgramme.containerGauche.containerProgrammeDeFormation.module1.creerUneBaseDeProspection.value', `Créer une base de prospection grâce au growth hacking`)" />
              </ka-text>
              <!-- Container -->
              <ka-container code="container-1" />
            </ka-container>
            <!-- Sections déroulantes -->
            <ka-container code="sections-deroulantes">
              <!-- Conteneur section -->
              <ka-container code="conteneur-section">
                <DropDownFormation
                  instance-class="drop-down-formation--p34"
                  titre="I.   Les bases marketing de la prospection digitale"
                  :arguments="page.$constants.dropDownFormationArguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-2">
                <DropDownFormation
                  instance-class="element-4--p34"
                  titre="II.   Savoir analyser les techniques de prospection automatisée"
                  :arguments="page.$constants.element4Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-3">
                <DropDownFormation
                  instance-class="element-5--p34"
                  titre="III.  Analyser les outils CRM utilisés"
                  :arguments="page.$constants.element5Arguments" />
              </ka-container>
            </ka-container>
            <!-- Module2 -->
            <ka-container code="module-2">
              <ka-text code="automatiser-sa-prospection">
                <h2 v-html="t('prog04GrowthHacking.pageFormation.containerProgramme.containerGauche.containerProgrammeDeFormation.module2.automatiserSaProspection.value', `Automatiser sa prospection grâce au marketing automation`)" />
              </ka-text>
              <!-- Container -->
              <ka-container code="container-4" />
            </ka-container>
            <!-- Module2 -->
            <ka-container
              code="container-5"
              :options="{ hidden: true }"
              :xs="{ hidden: false }">
              <ka-text code="text-1">
                <h2 v-html="t('prog04GrowthHacking.pageFormation.containerProgramme.containerGauche.containerProgrammeDeFormation.container5.text1.value', `Module 1`)" />
                <template #xs>
                  <h2 v-html="t('prog04GrowthHacking.pageFormation.containerProgramme.containerGauche.containerProgrammeDeFormation.container5.text1.xs.value', `Module 2`)" />
                </template>
              </ka-text>
              <!-- Container -->
              <ka-container code="container-6" />
            </ka-container>
            <!-- Sections déroulantes -->
            <ka-container code="container-7">
              <!-- Conteneur section -->
              <ka-container code="container-8">
                <DropDownFormation
                  instance-class="element-6--p34"
                  titre="I.   Coupler le marketing Automation et CRM"
                  :arguments="page.$constants.element6Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-9">
                <DropDownFormation
                  instance-class="element-7--p34"
                  titre="II.   Mettre en œuvre sa stratégie de Marketing Automation"
                  :arguments="page.$constants.element7Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-10">
                <DropDownFormation
                  instance-class="element-8--p34"
                  titre="III.  Mesurer et optimiser l'efficacité des actions"
                  :arguments="page.$constants.element8Arguments" />
              </ka-container>
            </ka-container>
          </ka-container>
          <CtaProgrammeSurMesurePrendreRdv instance-class="cta-programme-sur-mesure-prendre-rdv--p34" />
        </ka-container>
        <BlocArgCtaRdvPedagogieMatchers
          instance-class="bloc-arg-cta-rdv-pedagogie-matchers--p34"
          :xs="{ hidden: null }"
          expert-1="https://ucarecdn.com/317c648e-e707-43df-8f87-df66b9823bdf/profil_expert_Anne-Sophie.svg" />
      </ka-container>
      <BlocArgPasDeFraisPasDeDemarchesAdministratives instance-class="bloc-arg-pas-de-frais-pas-de-demarches-admi--p34" />
      <PFormationMatching
        instance-class="p-formation-matching--p34"
        :options="{ hidden: null }"
        description-company="<strong>Algo Solutions</strong> | Entreprise proposant des prestations d'ingéniérie pour la valorisation et l'exploitation des données scientifiques.<br> <br> <br><strong>Besoin : </strong>Automatiser son acquisition client."
        expert-text="<strong>Romain </strong>| Chargé d'Affaires Incubation | &#64;SATT AxLR.<br> <br> <br> <br><strong>Expertise : </strong>Accompagmement d'entrepreneurs depuis 2014, conseil stratégique et levée de fonds."
        budget-available="1 200€"
        training-hours="8h"
        photo-expert="https://ucarecdn.com/378a3fb1-e13c-4289-89f5-33ee648c1e1c/"
        image="https://ucarecdn.com/c7c605b0-465f-46be-86e6-80f0f752e66d/" />
      <BlocReassuranceQualiopi instance-class="bloc-reassurance-qualiopi--p34" />
      <PFormationCriteresQualiopi instance-class="p-formation-criteres-qualiopi--p34" />
      <PFormationPourquoiSeFormer
        instance-class="p-formation-pourquoi-se-former--p34"
        text="Pourquoi se former en growth hacking avec Matchers ?"
        text-1="Nous avons demandé à une intelligence artificielle de nous expliquer ce qu'était le <strong>growth hacking</strong> comme si nous étions un enfant de 10 ans. Voici sa réponse :<br> <br>“Le Growth Hacking, c'est comme une baguette magique pour <strong>faire grandir rapidement une entreprise</strong>. Imagine que tu as une petite entreprise et que tu veux attirer plus de clients ou faire connaître tes produits ou services à plus de personnes. Le Growth Hacking consiste à<strong> trouver des moyens astucieux et créatifs</strong> pour faire grandir ton entreprise, même si tu n'as pas beaucoup d'argent ou de ressources.”<br> <br>Sa définition vend du rêve n’est ce pas ? <br> <br>Le terme Growth Hacker a été introduit pour la première fois en 2010 par Sean Ellis (ancien de Dropbox) sur son blog www.startup-marketing.com. Selon lui, le Growth Hacker et toutes les actions qu’il réalise sont <strong>conditionnés</strong> par un seul et unique <strong>objectif</strong> : la <strong>croissance</strong> !<br> <br>Le growth hacking, depuis, est devenu une <strong>discipline</strong>, un <strong>intitulé de poste </strong>et se retrouve dans beaucoup d’actions que les entreprises mettent en place."
        image="https://ucarecdn.com/b6ae782e-8231-4a70-b01c-9008dd67b211/" />
    </ka-container>
    <!-- Sections du domaine -->
    <ka-container code="sections-du-domaine">
      <PFormationSectionBleu
        instance-class="p-formation-section-bleu--p34"
        paragraph="Le <strong>marketing digital</strong> qui consiste à activer différents <strong>canaux digitaux</strong> pour générer de la notoriété, des prospects et des ventes, présente le même <strong>objectif</strong> que le <strong>growth hacking</strong> : <strong>développer son entreprise</strong>. <br> <br>La différence ? <br> <br>Le <strong>growth hacking</strong> se concentre sur des processus <strong>itératifs</strong> et <strong>d’optimisation</strong> <strong>continue</strong> à chaque étape de l'entonnoir marketing."
        title="Quelle différence entre le marketing digital et le growth hacking ?"
        picture="https://ucarecdn.com/ee1778a6-4b9e-4d8c-9be9-0d9ea936d0ad/" />
      <PFormationSectionBanche
        instance-class="p-formation-section-banche--p34"
        paragraph="Pour vous donner un exemple précis, le principe de devoir donner son adresse email pour obtenir un livre blanc (télécharge un PDF ou utiliser un outil) est une technique de growth hacking. <br> <br>Toutes les actions mises en place en growth hacking sont souvent la combinaison d’un peu (ou beaucoup) de technique et d’une idée maline."
        title="Ingéniosité, fondement du growth hacking"
        picture="https://ucarecdn.com/4dc2cdc5-e61c-40e5-b6a6-37cca2f398ad/" />
      <PFormationSectionBleu
        instance-class="element-9--p34"
        paragraph="Être accompagné par un expert en growth hacking vous permettra de mettre en place des <strong>techniques créatives et astucieuses </strong>dans l'objectif de constituer une base de prospection ou encore d'instaurer un scrapping automatisé de nouveaux prospects. <br> <br>Voici plusieurs <strong>objectifs</strong> sur lesquels le <strong>growth hacking</strong> pourrait bien être la <strong>clé</strong> de votre projet.<br> <br><strong>Optimiser le taux de conversion sur le site web</strong> 👉 En utilisant des tests A/B, des pop-ups intelligents, des incitations à l'action bien placées et des formulaires de capture de leads optimisés, une entreprise peut améliorer significativement son <strong>taux de conversion</strong>. Un expert en growth hacking pourra vous permettre de prendre du recul et d’identifier les éléments les plus performants à mettre en œuvre d’après votre structure et vos objectifs de croissance.<br> <br><strong>Lancer des campagnes de parrainage</strong> 👉 Technique puissante pour attirer de nouveaux clients, elle consiste à mettre en place des <strong>programmes de parrainage incitatifs </strong>en offrant des récompenses aux clients qui recommandent leurs produits ou services à leurs amis. <br>Les clients existants deviennent alors des <strong>ambassadeurs de la marque</strong> et génèrent de <strong>nouveaux prospects</strong> de manière organique. Si cette technique vous intéresse, une formation sur-mesure avec l’un de nos experts pourrait bien répondre à toutes vos questions ! <br> <br><strong>Expérimenter avec des canaux de distribution alternatifs</strong> 👉 Le growth hacking encourage l'<strong>exploration de canaux de distribution non conventionnels</strong> pour atteindre de nouveaux publics. <br>Par exemple, une entreprise peut utiliser des plateformes de partage de contenu, des forums en ligne, des marketplaces spécialisées, ou même des partenariats stratégiques pour augmenter sa visibilité et générer de nouveaux clients.<br> <br>Comme dans tout nouveau projet, notre expert vous accompagne également dans le <strong>suivi de vos actions et l’évaluation de leurs performances</strong>. Quels KPI suivre, pourquoi ? Que faire si mes objectifs ne sont pas atteints ?"
        title="La croissance, un objectif à travers chaque action"
        picture="https://ucarecdn.com/310d87a9-0389-4426-8c5d-db2b6115245e/" />
      <PFormationSectionBanche
        instance-class="element-10--p34"
        paragraph="Si ce domaine ne vous paraît toujours pas très clair, c'est normal.<br> <br>Les <strong>actions possibles varient énormément </strong>en fonction des organisations, de leur taille et leurs objectifs. <br> <br>Le nôtre reste de vous faire accompagner par un expert pour mettre en place les actions qui pourront rapidement <strong>contribuer à votre croissance</strong> ! Car oui, dans ce cas précis, il peut effectivement s’agir de <strong>growth hacking</strong>. <br> <br>La particularité c’est que dans ce domaine, tout a toujours vocation à changer, être optimisé, aller plus vite, etc."
        title="Le growth hacking ce n’est pas un peu tout et n’importe quoi ?"
        picture="https://ucarecdn.com/3b09a966-1076-43b0-8518-f5d43e5eda39/" />
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { formationsGrowthHacking } from './store'
import BlocArgCtaRdvPedagogieMatchers from '~/components/BlocArgCtaRdvPedagogieMatchers/index.vue'
import BlocArgPasDeFraisPasDeDemarchesAdministratives from '~/components/BlocArgPasDeFrais/PasDeDemarchesAdministratives/index.vue'
import BlocPreviewProfilExpert from '~/components/BlocPreviewProfilExpert/index.vue'
import BlocReassuranceQualiopi from '~/components/BlocReassuranceQualiopi/index.vue'
import CtaProgrammeSurMesurePrendreRdv from '~/components/CtaProgrammeSurMesurePrendreRdv/index.vue'
import DropDownFormation from '~/components/DropDownFormation/index.vue'
import PFormationCriteresQualiopi from '~/components/PFormationCriteresQualiopi/index.vue'
import PFormationEntete from '~/components/PFormationEntete/index.vue'
import PFormationMatching from '~/components/PFormationMatching/index.vue'
import PFormationPourquoiSeFormer from '~/components/PFormationPourquoiSeFormer/index.vue'
import PFormationSectionBanche from '~/components/PFormationSectionBanche/index.vue'
import PFormationSectionBleu from '~/components/PFormationSectionBleu/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p34')
const appData = appDataStore()
const page = formationsGrowthHacking()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
